import type {NumberWithCommasType} from '@qep/types/src';

export function numberWithCommas(args: NumberWithCommasType): string | 0 {
	const {value, minimumFractionDigits = 4, maximumFractionDigits, defaultValue = 0} = args;
	if (value === undefined || value === null) {
		return defaultValue;
	}

	const numericValue = Number(value);
	if (Number.isFinite(numericValue)) {
		return numericValue.toLocaleString('en-US', {
			minimumFractionDigits,
			maximumFractionDigits,
		});
	}

	return '';
}
